// Axios errors come in three shapes. This normalises them to one string.
export const extractErrorMessage = (error) => {
  // 1. Server responded with an error status (400/401/403/500)
  if (error.response) {
    return error.response.data?.message || 'Something went wrong. Please try again.';
  }

  // 2. Request sent but no response — server down, CORS, network off
  if (error.request) {
    return 'Cannot reach the server. Please check your connection.';
  }

  // 3. Something broke before the request was even sent
  return error.message || 'Unexpected error.';
};
